/* tslint:disable */
/* eslint-disable */
/**
 * e-SNRWB
 * Opis api e-SNRWB
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FilterNegativeTestDataExtended
 */
export interface FilterNegativeTestDataExtended {
    /**
     * 
     * @type {boolean}
     * @memberof FilterNegativeTestDataExtended
     */
    onlyCpr: boolean;
    /**
     * 
     * @type {Date}
     * @memberof FilterNegativeTestDataExtended
     */
    dateFrom?: Date;
    /**
     * 
     * @type {Date}
     * @memberof FilterNegativeTestDataExtended
     */
    dateTo?: Date;
    /**
     * 
     * @type {string}
     * @memberof FilterNegativeTestDataExtended
     */
    organizationalUnitId?: string;
    /**
     * 
     * @type {string}
     * @memberof FilterNegativeTestDataExtended
     */
    productDescription?: string;
    /**
     * 
     * @type {string}
     * @memberof FilterNegativeTestDataExtended
     */
    product?: string;
    /**
     * 
     * @type {Date}
     * @memberof FilterNegativeTestDataExtended
     */
    dateFromProtocol?: Date;
    /**
     * 
     * @type {Date}
     * @memberof FilterNegativeTestDataExtended
     */
    dateToProtocol?: Date;
}

export function FilterNegativeTestDataExtendedFromJSON(json: any): FilterNegativeTestDataExtended {
    return FilterNegativeTestDataExtendedFromJSONTyped(json, false);
}

export function FilterNegativeTestDataExtendedFromJSONTyped(json: any, ignoreDiscriminator: boolean): FilterNegativeTestDataExtended {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'onlyCpr': json['onlyCpr'],
        'dateFrom': !exists(json, 'dateFrom') ? undefined : (new Date(json['dateFrom'])),
        'dateTo': !exists(json, 'dateTo') ? undefined : (new Date(json['dateTo'])),
        'organizationalUnitId': !exists(json, 'organizationalUnitId') ? undefined : json['organizationalUnitId'],
        'productDescription': !exists(json, 'productDescription') ? undefined : json['productDescription'],
        'product': !exists(json, 'product') ? undefined : json['product'],
        'dateFromProtocol': !exists(json, 'dateFromProtocol') ? undefined : (new Date(json['dateFromProtocol'])),
        'dateToProtocol': !exists(json, 'dateToProtocol') ? undefined : (new Date(json['dateToProtocol'])),
    };
}

export function FilterNegativeTestDataExtendedToJSON(value?: FilterNegativeTestDataExtended | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'onlyCpr': value.onlyCpr,
        'dateFrom': value.dateFrom === undefined ? undefined : (value.dateFrom.toISOString()),
        'dateTo': value.dateTo === undefined ? undefined : (value.dateTo.toISOString()),
        'organizationalUnitId': value.organizationalUnitId,
        'productDescription': value.productDescription,
        'product': value.product,
        'dateFromProtocol': value.dateFromProtocol === undefined ? undefined : (value.dateFromProtocol.toISOString()),
        'dateToProtocol': value.dateToProtocol === undefined ? undefined : (value.dateToProtocol.toISOString()),
    };
}


